module.exports = new __parcel__URL__("kitten1.c7908a10.png").toString();